<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="540px">
        <div class="row">
            <div class="col-6">
                <x-date-picker v-model="form.date_of_issue"
                               label="Fecha de emisión"></x-date-picker>
            </div>
            <div class="col-12">
                <x-switch-left v-model="form.is_quantity"
                               label="Generar por cantidad total"></x-switch-left>
            </div>
            <div class="col-6" v-if="!form.is_quantity">
                <x-input v-model="form.total_global"
                         label="Monto total"></x-input>
            </div>
            <div class="col-6" v-else>
                <x-input v-model="form.quantity_global"
                         label="Cantidad total"></x-input>
            </div>
            <div class="col-6">
                <x-input v-model="form.unit_price"
                         label="Precio unitario"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit"
                                 :disabled="loading"
                                 text="Generar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel"
import XButtonSubmit from "../../../../components/Form/XButtonSubmit"
import XModal from "../../../../components/XModal"
import XInput from "../../../../components/Form/XInput.vue"
import XSelect from "../../../../components/Form/XSelect.vue"
import XDatePicker from "../../../../components/Form/XDatePicker.vue"
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue"
import moment from "moment/moment";
import XSwitchLeft from "../../../../components/Form/XSwitchLeft.vue";

export default {
    name: 'DocumentRandom',
    components: {XSwitchLeft, XInputItemSearch, XDatePicker, XSelect, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'store',
            errors: {},
            form: [],
        }
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.loading = false
            this.title = 'Generar boletas masivas'
            this.errors = {}
            this.form = {
                date_of_issue: moment().format('YYYY-MM-DD'),
                quantity_global: 0,
                total_global: 0,
                unit_price: 0,
                is_quantity: true
            }
        },
        handleOpen() {
            this.initForm()
        },
        async onSubmit() {
            if (this.form.unit_price === 0 || this.form.unit_price === '' || this.form.unit_price === null) {
                return this.$message.error('El precio unitario es incorrecto')
            }

            if(this.form.is_quantity) {
                if (this.form.quantity_global === 0 || this.form.quantity_global === '' || this.form.quantity_global === null) {
                    return this.$message.error('La cantidad total es incorrecto')
                }
            } else {
                if (this.form.total_global === 0 || this.form.total_global === '' || this.form.total_global === null) {
                    return this.$message.error('La cantidad total es incorrecto')
                }
            }

            this.loading = true
            await this.$http.post('/documents/generate_random', this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$emit('success')
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                }).finally(() => {
                    this.loading = false
                })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
